/**
 * Llenar un formulario.
 *
 * `formulario` here, `hoja` on the QR page, and that is deliberate — see dict/es/dailyReport.js. This
 * screen sits inside the application, where the nav strip says `Formularios` and a foreman moves
 * between the two; the QR page is read by field hands who never see that strip.
 *
 * `firma` / `Sin firmar` are taken verbatim from the QR page's dictionary rather than re-decided, so
 * the same signature pad does not describe itself two ways to two people looking at the same sheet.
 *
 * ⚠ Esto es solo el marco de la pantalla. Lo que el supervisor de veras LEE — las preguntas del
 * formulario — todavía sale en inglés dentro de la aplicación aunque el inquilino ya las haya
 * traducido. Ver el archivo en inglés: la página del código QR sí las traduce y esta no.
 */
export default {
  // ── el módulo ─────────────────────────────────────────────────────────────────────────────────
  forms: 'Formularios',
  backToForms: 'Volver a formularios',

  // ── la barra del módulo ───────────────────────────────────────────────────────────────────────
  // `Enviados` para Submissions, no `Envíos`: es la misma palabra que el botón `Enviar` que el
  // supervisor acaba de tocar, así que la pestaña dice a dónde se fue lo que mandó.
  navTemplates: 'Plantillas',
  navAssignments: 'Asignaciones',
  navSigningRules: 'Reglas de firma',
  navFill: 'Llenar un formulario',
  navSubmissions: 'Enviados',

  // ── permisos ──────────────────────────────────────────────────────────────────────────────────
  cannotFillTitle: 'Usted no puede llenar formularios',
  cannotFillBody: 'Su cuenta no tiene el permiso de «enviar formularios».',
  cannotFillBodyAskAdmin: 'Su cuenta no tiene el permiso de «enviar formularios». Pídale a un '
    + 'administrador que se lo dé.',

  // ── escoger ───────────────────────────────────────────────────────────────────────────────────
  fillOutAForm: 'Llenar un formulario',
  pickAForm: 'Escoja un formulario para empezar, o siga uno que ya había comenzado.',
  loadingForms: 'Cargando formularios…',
  searchForms: 'Buscar formularios…',
  continueWhereYouLeftOff: 'Siga donde se quedó',
  noPublishedForms: 'Todavía no hay formularios publicados.',
  noFormsMatch: 'Ningún formulario coincide con su búsqueda.',

  // ── llenarlo ──────────────────────────────────────────────────────────────────────────────────
  openingForm: 'Abriendo el formulario…',
  couldNotOpen: 'No se pudo abrir este formulario',
  practiceRunTitle: 'Eso fue una práctica',
  alreadySubmitted: 'Este formulario ya se envió, así que solo se puede leer.',
  autosaveHint: 'Sus respuestas se guardan solas mientras escribe.',
  saving: 'Guardando…',
  saved: 'Guardado',
  notSaved: 'No se guardó',
  submitting: 'Enviando…',
  submit: 'Enviar',
  submitted: 'Enviado',
  fillOutAnother: 'Llenar otro formulario',
  done: 'Listo',

  // ── los campos ────────────────────────────────────────────────────────────────────────────────
  notSigned: 'Sin firmar',
  signature: 'Firma',
  remove: 'Quitar',
  removeRow: 'Quitar la fila',
  noRows: 'Sin filas',
  noRowsYet: 'Todavía no hay filas — agregue la primera.',
  addRow: '+ Agregar fila',
  crewListUnavailable: 'No se pudo cargar la lista de cuadrillas.',
  loadingCrews: 'Cargando cuadrillas…',
  noCrewsYet: 'Todavía no hay cuadrillas.',
  noCrewsYetHelp: 'Agregue una en Control de horas → Cuadrillas.',
  noFieldsYet: 'Este formulario todavía no tiene campos.',
  noContentYet: 'Este formulario todavía no tiene contenido.',

  // ── el panel del reporte ──────────────────────────────────────────────────────────────────────
  formsOnThisRecord: 'Formularios de este registro',
  addAForm: 'Agregar un formulario',
  couldNotLoadRecordForms: 'No se pudieron cargar los formularios de este registro.',
  couldNotLoadRecordFormsHelp1: 'Esto',
  couldNotLoadRecordFormsNot: 'no',
  couldNotLoadRecordFormsHelp2: 'quiere decir que no se llenó ninguno — ahorita no se sabe cuáles '
    + 'hay. Nada más de esta página se ve afectado.',
  tryAgain: 'Intentar otra vez',
  carriedForward: 'traído del anterior',
  onlyYourOwn: 'Solo puede ver los formularios que usted mismo llenó.',
  chooseAForm: 'Escoja un formulario',
  couldNotLoadFormList: 'No se pudo cargar la lista de formularios. Intente en un momento.',
  noPublishedFormsYet: 'Todavía no hay formularios publicados. Un formulario tiene que publicarse '
    + 'antes de poder llenarse.',
  alreadyFiled: 'ya se entregó — ábralo arriba',
  required: 'Obligatorio',
  otherForms: 'Otros formularios',
  close: 'Cerrar',
}
